<template>
  <el-form-item :label="label" :prop="field" :rules="rules" size="small">
    <el-checkbox-group :value="value" @input="$emit('input', $event)">
      <el-checkbox v-for="item in options" :label="item.value" :disabled="item.disabled" :key="item.value">{{ item.label }}</el-checkbox>
    </el-checkbox-group>
  </el-form-item>
</template>

<script>
export default {
  name: 'app-type-checkbox',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    field: {
      type: String
    },
    value: {
      type: [ Array ],
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    rules: {
      type: [ Object, Array ]
    },
    placeholder: {
      type: String,
      default: '请在此输入内容'
    }
  }
}
</script>
